import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Dispatch } from '@reduxjs/toolkit'
import { claimRecordsApi } from '@redux/queries/claimRecords'
import { configApi } from '@redux/queries/config'
import { insurersApi } from '@redux/queries/insurers'
import { resetCtaInitialState } from '@redux/slices/ctaSlice'
import { resetFormsInitialState } from '@redux/slices/formsSlice'
import { resetWorkflowInitialState } from '@redux/slices/workflowSlice'
import { resetInsuranceMemberState } from '@redux/slices/insuranceMemberSlice'
import { resetClaimStatusInitialState } from '@redux/slices/claimStatusSlice'
import { resetPrescriptionFileInitialState } from '@redux/slices/prescriptionFileSlice'
import { overviewResetInitialState } from '@redux/slices/overviewWidgetSlice'
import { connectorLogoutInProgress } from '@redux/slices/connectorSlice'
import { ApiCache } from '@redux/queries/apiCache'

export const useLogoutEventHandler = (): (() => void) => {
  const dispatch = useDispatch()
  const [isInProgress, setIsInProgress] = useState(false)

  return useCallback(async () => {
    if (isInProgress) return

    setIsInProgress(true)

    try {
      resetState(dispatch)
      await ApiCache.cleanupCache()
    } finally {
      setIsInProgress(false)
    }
  }, [dispatch, isInProgress])
}

const resetState = (dispatch: Dispatch) => {
  dispatch(claimRecordsApi.util.resetApiState())
  dispatch(configApi.util.resetApiState())
  dispatch(insurersApi.util.resetApiState())

  dispatch(resetCtaInitialState())
  dispatch(resetFormsInitialState())
  dispatch(resetWorkflowInitialState())
  dispatch(resetInsuranceMemberState())
  dispatch(resetClaimStatusInitialState())
  dispatch(resetPrescriptionFileInitialState())
  dispatch(overviewResetInitialState())

  dispatch(connectorLogoutInProgress())
}
